import { connect } from 'react-redux';
import {
    clearManagedOrgs,
    fetchGetManagedOrgs,
    fetchInsertAccreditation,
    getManagedOrgsOptions,
    loadingManagedOrgs
} from '../../../reducers/accreditation/accreditations';
import {
    getCurrentContinent,
    setCurrentContinent,
    getCountriesData,
    getContinentsData,
    setCurrentContinentByCountry, getLocationData
} from '../../../reducers/common/location';
import { fetchGetLevels, getLevelsData } from '../../../reducers/common/levels';
import InsertAccreditation from './InsertAccreditation';
import { getSubmitFormSuccessStatus, fetchSubmitForm } from '../../../reducers/common/submitForm';
import { getTranslation } from "../../../reducers/common/localization";
import { fetchReGetGroups, getCurrentGroup, getCurrentGroupName } from "../../../reducers/account/role";
import { fetchGetTitleLangs, getOptionalTitleLangsData } from '../../../reducers/common/titleLangs';
import { getKey, getKeyLoading } from '../../../reducers/accreditation/certificate';
import {
    fetchGetOrg,
    isAccreditationSigningRequired,
    isOrgBava,
    loadingOrg
} from '../../../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        additionalLangs: getOptionalTitleLangsData(state),
        levels: getLevelsData(state),
        success: getSubmitFormSuccessStatus(state),
        translation: getTranslation(state),
        accreditationGroupId: getCurrentGroup(state),
        accreditationGroupName: getCurrentGroupName(state),
        signingKey: getKey(state),
        signingKeyLoading: getKeyLoading(state),
        isSigningRequired: isAccreditationSigningRequired(state),
        orgLoading: loadingOrg(state),
        isBava: isOrgBava(state),
        loadingManagedOrgs: loadingManagedOrgs(state),
        managedOrgs: getManagedOrgsOptions(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onInsert: (data) => {
            dispatch(fetchInsertAccreditation(data));
        },
        onSetSubmitFormLoading: () =>  dispatch(fetchSubmitForm()),
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onGetAccreditationGroups: () => {
            dispatch(fetchReGetGroups());
        },
        onGetAdditionalLangs: () => {
            dispatch(fetchGetTitleLangs());
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onGetOrganization: () => {
            dispatch(fetchGetOrg());
        },
        onGetManagedOrgs: (countryCode) => {
            dispatch(fetchGetManagedOrgs(countryCode));
        },
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry((countryCode)));
        },
        onUnmount: () => {
            dispatch(clearManagedOrgs());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsertAccreditation);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/insertAccreditation/InsertAccreditation.container.js